import Cookies from 'js-cookie';

export function isEighteenPopup() {
  const eighteenPopup = document.querySelector('.js-eighteen-popup');

  return eighteenPopup && !Cookies.get('eighteenConfirmation');
}
